import {get} from './common';

export const getStickers = async lang => {
    let url = 'https://stickers.cartoonnetworkla.com/service/get-packs';

    let result = await get(url);

    let packs = result.result
        .filter(pack => pack.stickers.length > 0)
        .map(pack => {
            let stickers = pack.stickers
                .filter(sticker =>
                    lang === 'por'
                        ? sticker.path_pt !== ''
                        : sticker.path_es !== '',
                )
                .map(sticker => {
                    let path =
                        lang === 'por' ? sticker.path_pt : sticker.path_es;
                    //make all paths the same :p
                    return {...sticker, path_pt: path, path_es: path};
                });
            let title = lang === 'por' ? pack.name_pt : pack.name_es;

            return {
                ...pack,
                stickers,
                name_pt: title,
                name_es: title,
            };
        })
        //remove null names
        .filter(pack => pack.name_pt && pack.name_es);

    if (packs) {
        return packs;
    }
    throw new Error('Sticker Packs failed');
};

export const getStickerImagePath = key => {
    return `https://stickers.cartoonnetworkla.com/service/get-image?key=${key}`;
};
